module.exports = __webpack_public_path__ + "71ac8bd213b2ed7d1287a66eec86ee23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order-now-600-x-338.png
// module id = 210
// module chunks = 0